(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-popover"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function allowHoverPopover() {
      var hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var isDesktop = window.matchMedia('(min-width: 750px)').matches;
      return hasHover && isDesktop;
    }

    document
      .querySelectorAll('.account-popover')
      .forEach(function (wrapper) {
        var trigger = wrapper.querySelector('.account-button[popovertarget]');
        var panel = wrapper.querySelector('.account-popover__panel[popover]');
        if (!trigger || !panel) return;

        trigger.addEventListener('click', function (event) {
          var isPhone = window.matchMedia('(max-width: 749px)').matches;
          if (!isPhone) return;

          var canShow = typeof panel.showPopover === 'function';
          var canHide = typeof panel.hidePopover === 'function';
          if (!canShow || !canHide) return;

          event.preventDefault();
          try {
            if (panel.matches(':popover-open')) {
              panel.hidePopover();
            } else {
              panel.showPopover();
            }
          } catch (e) {}
        });

        if (!allowHoverPopover()) return;

        var canShow = typeof panel.showPopover === 'function';
        var canHide = typeof panel.hidePopover === 'function';
        if (!canShow || !canHide) return;

        var hoverTimeout;

        function openPopover() {
          clearTimeout(hoverTimeout);
          try {
            panel.showPopover();
          } catch (e) {}
        }

        function closePopover() {
          hoverTimeout = setTimeout(function () {
            try {
              panel.hidePopover();
            } catch (e) {}
          }, 100);
        }

        wrapper.addEventListener('mouseenter', openPopover);
        wrapper.addEventListener('mouseleave', closePopover);
      });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__vessleMobileDrawerLoginCleanup) return;
    window.__vessleMobileDrawerLoginCleanup = true;

    function isPhoneLayout() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function cleanupLoginEntries() {
      if (!isPhoneLayout()) return;

      document.querySelectorAll('.menu-drawer .menu-drawer__menu-item').forEach(function (link) {
        var href = (link.getAttribute('href') || '').toLowerCase();
        var text = (link.textContent || '').trim().toLowerCase();
        var loginText = text === 'log in' || text === 'login' || text.indexOf('log in /') === 0;
        var loginHref =
          href.indexOf('/account/login') > -1 ||
          href.indexOf('/account/register') > -1 ||
          href.indexOf('/pages/custom-login') > -1;

        if (!loginText && !loginHref) return;

        var container = link.closest('.menu-drawer__list-item') || link.closest('li');
        if (container) {
          container.remove();
        } else {
          link.remove();
        }
      });

      document.querySelectorAll('.menu-drawer a').forEach(function (link) {
        var href = (link.getAttribute('href') || '').toLowerCase();
        if (
          href.indexOf('/account/login') === -1 &&
          href.indexOf('/account/register') === -1 &&
          href.indexOf('/pages/custom-login') === -1
        ) {
          return;
        }

        var wrapper = link.closest('.menu-drawer__list-item') || link.closest('li') || link.closest('.menu-drawer__utility-links');
        if (wrapper) {
          wrapper.remove();
        } else {
          link.remove();
        }
      });
    }

    cleanupLoginEntries();
    document.addEventListener('DOMContentLoaded', cleanupLoginEntries);
    document.addEventListener('shopify:section:load', cleanupLoginEntries);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    // Close the PRICE popup when the mouse leaves the panel (desktop only).
  document.addEventListener('DOMContentLoaded', () => {
    const panels = document.querySelectorAll('.facets__panel');

    panels.forEach((panel) => {
      if (!panel.querySelector('.price-facet')) return;

      panel.addEventListener('mouseleave', () => {
        // Avoid running on touch devices where hover doesn't exist
        if (matchMedia('(hover: hover)').matches === false) return;

        // Close details when pointer leaves the panel
        panel.removeAttribute('open');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const dialogComponent = document.getElementById('search-modal');
    if (!dialogComponent) return;

    const dialog = dialogComponent.querySelector('dialog.search-modal__content');
    if (!dialog) return;

    // Close when mouse leaves the white popup area
    dialog.addEventListener('mouseleave', function (event) {
      const toElement = event.relatedTarget;
      if (!toElement || !dialog.contains(toElement)) {
        try {
          dialog.close();
        } catch (e) {}
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
